import React, { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { downloadExcel, GetFilterUrl, showToastNotification } from '@/utility/helper';
import { API_URL } from '@/api/constant';
import { IAnalyticsFilters } from '@/interfaces/Dashboard/dashboard.interface';
import { ThrowError } from '@/api/callApi';

interface AnalyticsExportButtonProps {
    label?: string;
    exportUrl: string;
    fileName: string;
    filters: IAnalyticsFilters;
    className?: string;
}

export const AnalyticsExportButton: React.FC<AnalyticsExportButtonProps> = ({
    label = "Export Excel",
    exportUrl,
    fileName,
    filters,
    className = ''
}) => {
    const [isExporting, setIsExporting] = useState(false);

    const handleExport = async () => {
        setIsExporting(true);
        try {
            const paramsStr = GetFilterUrl(filters as any);
            // Prepend API_URL if the exportUrl is a relative path
            const baseUrl = exportUrl.startsWith('http') ? exportUrl : `${API_URL}${exportUrl}`;
            const urlWithParams = `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}${paramsStr}`;
            await downloadExcel(urlWithParams, fileName);
            showToastNotification('success', 'Report downloaded successfully');
        } catch (error) {
            ThrowError(error);
        } finally {
            setIsExporting(false);
        }
    };

    return (
        <Button
            variant="outline"
            size="sm"
            onClick={handleExport}
            disabled={isExporting}
            className={`flex items-center gap-2 ${className}`}
        >
            {isExporting ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
            {label}
        </Button>
    );
};
